import _ from 'underscore';
import textViewTemplate from './template/text-view.pug';

export function renderTextView(textView) {
  const options = _.defaults({}, textView, {
    classes: [],
    id: _.uniqueId('text-view-'),
  });
  const html = textViewTemplate(options);
  const events = {};

  return { html, events };
}
